import React, { useState }  from 'react'
import UiKit                from "../../../../../common/uikit"
import parse                from "react-html-parser"
import { useSelector }      from 'react-redux';
import {
    useDomain
}                           from '../../../../../hooks/use';
import axios                from 'axios';

const Blog = () => {
    const redux         = useSelector( state => ({
        isLoading       : state.getIn([ 'ui', 'provider', 'isLoading', 'Load_Product_Domain_Data' ]),
        token           : state.getIn([ 'domain', 'account', 'auth', 'token'])
    }));
    const { blog }      = useDomain({ Blog: {} });
    const token         = redux.token ? redux.token : null;
    const [s, setState] = useState({
        blogs: {
            content     : "",
            title       : null,
            image       : null,
            slug        : "asdad",
            summary     : "asdad",
            category    : "asdad",
        }
    })
    const formData = new FormData();

    const convertToFormData = () => {
        formData.append('blog_content', s.blogs.content);
        formData.append('blog_title',   s.blogs.title);
        formData.append('blog_photo',   s.blogs.image);
        formData.append('blog_slug',   s.blogs.slug);
        formData.append('blog_summary',   s.blogs.summary);
        formData.append('blog_catagory',   s.blogs.category);
    }
    
    // const languageOption = [
    //     {
    //         "text" : "türkçe",
    //         "value": 0
    //     },
    //     {
    //         "text" : "english",
    //         "value": 1
    //     },
    // ]
    
    // const languageOptions = () => {
    //     return languageOption.map(l => ({
    //         text    : l.text,
    //         value   : l.value
    //     }))
    // }

    const changeFilterModel = (node, value) => {
        let filterModel     = Object.assign({}, s.blogs);
        filterModel[node]   = value;
        setState({
            blogs: filterModel
        });
    }

    const createBlog = () => {
        convertToFormData();
        axios.post(`${process.env.REACT_APP_API}/api/blog`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        })
    }

    return (
        <div className="add-blog-container">
        <div>
        <form className="form-wrapper">
                <UiKit.Row className="mt25">
                    <UiKit.Col className="p8" sm="12" md="12">
                        <UiKit.Textfield
                            full
                            required
                            placeholder = "blog title"
                            value       = { s.blogs.title }
                            onChange    = { value => changeFilterModel('title', value) }
                            // errors      = { s.errors['website'] }
                            // isDisabled  = { redux.isLoading }
                        />
                    </UiKit.Col>
                </UiKit.Row>
                <UiKit.Row className="mt25">
                    <UiKit.Col className="p8"sm="12" md="12">
                        <div className="file-upload">
                            <input 
                                type        = "file" 
                                name        = "file"
                                placeholder = "Resim eklemek icin tikla..."
                                onChange    = { event => changeFilterModel('image', event.target.files[0]) }
                            />
                        </div>
                    </UiKit.Col>
                    { /*
                        <UiKit.Col className="p8"sm="6" md="6">
                            <UiKit.Dropdown
                                full
                                required
                                placeholder  = "Dil Seçiniz"
                                options      = { languageOptions() }
                                onChange     = { ({ value }) => changeFilterModel('lan', value) }
                                value        = { s.lan }
                            />
                        </UiKit.Col>
                    */}
                </UiKit.Row>
            </form>
        </div>
            <div className="blog-text">
                <p>Blog detayi giriniz</p>
                <div className="editor">
                    <UiKit.Editor
                        data    = { s.blogs.content }
                        edit    = { (value) => changeFilterModel('content',value) }
                        plugIns = {[ 'key-binder' ]}
                    />
                </div>
            </div>
           <div className="show-wrapper">
                <h1>Son Haline Göz At 🧐</h1>
                <div className="show-blog">
                    {s.blogs.content && parse(s.blogs.content)}
                </div>
           </div>
           <div className="footer">
               <button onClick={createBlog}>Yayınla</button>
           </div>
        </div>
    )
}

export default Blog
